import { Form as Form$1 } from 'formik';
import React__default from 'react';
import styled from 'styled-components';

const StyledFormikForm = styled(Form$1)`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const Form = ({ children , ...props })=>{
    return React__default.createElement(StyledFormikForm, {
        ...props
    }, children);
};
Form.dataId = "data-hpy-web-form";
Form.displayName = "Form";

export { Form };
